app.directive("acRightSide", ['$rootScope', function($rootScope) {
    return {
        link: function(scope, element, attributes) {
            
            if($(".ac-side").length == 0){
                $("[ac-right-side]").css("display", "none")
            }
            
            $("body").on("click", function(e){
                if (e.target.id == "ac-side" || $(e.target).parents(".ac-side").length || e.target.id == "openRightSideButton"|| $(e.target).parents("#openRightSideButton").length) {

                }else{
                    $(".ac-side").removeClass("ac-side-show")   
                }
                
            })
            element.bind("click", function(event) {
                $(".ac-side").addClass("ac-side-show")   
            });
        }
    }
}]);